<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn outlined v-on="on" class="mr-2">
        <v-icon left>mdi-plus</v-icon>Add Custom Row
      </v-btn>
    </template>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>Add Custom Row</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                  v-model.lazy="model.custom_label"
                  label="Description"
                  clearable
                  :rules="[v => !!v || 'Description is required']"
              />
            </v-col>
            <v-col>
              <v-text-field
                  v-model.lazy="model.quantity"
                  label="Quantity"
                  type="number"
                  :rules="[v => v>0 || 'Quantity must be greater than 0', v => !isNaN(v) || 'Quantity must be a number', v => !/^\s*$/.test(v) || 'Quantity must not be empty']"
              />
            </v-col>
            <v-col>
              <v-text-field
                  v-model.lazy="model.unitPrice"
                  label="Unit Price"
                  type="number"
                  :rules="[v => v>0 || 'Unit Price must be greater than 0', v => !isNaN(v) || 'Unit Price must be a number', v => !/^\s*$/.test(v) || 'Unit Price must not be empty']"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              @click="submit"
          >
            Add Custom Row
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: 'AddCustomRow',
  data: () => ({
    valid: false,
    model:{
      custom_label: "",
      quantity: 1,
      unitPrice: 0,
    },
    dialog:false
  }),
  props: {
      orderId: {
        type: Number
      }
  },
  methods:{
    ...mapActions('orders', ['addCustomRow']),
    submit(){
      if(this.$refs.form.validate()){
        this.addCustomRow({orderId: this.orderId, model: this.model})
            .then(result => {
              this.resetForm();
              this.$emit("added", result);
              this.flashMessage.success({
                message: "Custom row added successfully",
              });
            })
      }
    },
    resetForm() {
      this.dialog = false;
      this.model.custom_label = "";
      this.model.quantity = 1;
      this.model.unitPrice = 0;
    }
  }

}
</script>

<style scoped>

</style>